import React from 'react';

export const Privacy: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-4xl font-bold mb-8">Politique de Confidentialité</h1>
      
      <div className="prose max-w-none">
        <p className="text-gray-600 mb-6">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">1. Introduction</h2>
          <p className="text-gray-700 leading-relaxed">
            CoKilo s'engage à protéger la vie privée de ses utilisateurs. Cette politique de confidentialité explique comment nous collectons, utilisons, partageons et protégeons vos données personnelles conformément au RGPD (Règlement Général sur la Protection des Données).
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">2. Données collectées</h2>
          
          <h3 className="text-xl font-semibold mt-4 mb-3">2.1 Données d'identification</h3>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Nom et prénom</li>
            <li>Adresse email</li>
            <li>Numéro de téléphone</li>
            <li>Date de naissance</li>
            <li>Photo d'identité (via Stripe Identity)</li>
          </ul>

          <h3 className="text-xl font-semibold mt-4 mb-3">2.2 Données de paiement</h3>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Coordonnées bancaires (traitées par Stripe)</li>
            <li>Historique des transactions</li>
          </ul>

          <h3 className="text-xl font-semibold mt-4 mb-3">2.3 Données de navigation</h3>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Adresse IP</li>
            <li>Données de géolocalisation</li>
            <li>Cookies et technologies similaires</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">3. Utilisation des données</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            Nous utilisons vos données pour :
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Créer et gérer votre compte</li>
            <li>Faciliter les transactions entre utilisateurs</li>
            <li>Vérifier votre identité et prévenir la fraude</li>
            <li>Traiter les paiements</li>
            <li>Améliorer nos services</li>
            <li>Vous envoyer des notifications importantes</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">4. Partage des données</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            Nous partageons vos données uniquement avec :
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li><strong>Stripe :</strong> Pour le traitement des paiements et la vérification d'identité</li>
            <li><strong>Autres utilisateurs :</strong> Informations nécessaires à la transaction (nom, note)</li>
            <li><strong>Autorités légales :</strong> En cas de demande légale</li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-3">
            Nous ne vendons jamais vos données personnelles à des tiers.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">5. Sécurité des données</h2>
          <p className="text-gray-700 leading-relaxed">
            Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, perte ou destruction, notamment :
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-3">
            <li>Chiffrement SSL/TLS pour toutes les communications</li>
            <li>Hashage bcrypt des mots de passe</li>
            <li>Serveurs sécurisés hébergés sur DigitalOcean</li>
            <li>Accès restreint aux données personnelles</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">6. Vos droits</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            Conformément au RGPD, vous disposez des droits suivants :
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li><strong>Droit d'accès :</strong> Obtenir une copie de vos données</li>
            <li><strong>Droit de rectification :</strong> Corriger vos données inexactes</li>
            <li><strong>Droit à l'effacement :</strong> Supprimer votre compte et vos données</li>
            <li><strong>Droit à la portabilité :</strong> Recevoir vos données dans un format lisible</li>
            <li><strong>Droit d'opposition :</strong> S'opposer au traitement de vos données</li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-3">
            Pour exercer ces droits, contactez-nous via notre formulaire de contact.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">7. Conservation des données</h2>
          <p className="text-gray-700 leading-relaxed">
            Nous conservons vos données personnelles aussi longtemps que nécessaire pour fournir nos services et respecter nos obligations légales. Les données de transaction sont conservées pendant 10 ans conformément aux obligations comptables.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">8. Cookies</h2>
          <p className="text-gray-700 leading-relaxed">
            Nous utilisons des cookies essentiels pour le fonctionnement de la plateforme (authentification, préférences). Vous pouvez désactiver les cookies dans les paramètres de votre navigateur, mais cela peut affecter le fonctionnement du site.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">9. Modifications</h2>
          <p className="text-gray-700 leading-relaxed">
            Nous pouvons modifier cette politique de confidentialité à tout moment. Les modifications seront publiées sur cette page avec une nouvelle date de mise à jour.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">10. Contact</h2>
          <p className="text-gray-700 leading-relaxed">
            Pour toute question concernant cette politique de confidentialité ou vos données personnelles, contactez-nous via notre formulaire de contact.
          </p>
        </section>
      </div>
    </div>
  );
};